var parent = require('../../../actual/array/virtual/find-index');

module.exports = parent;
